import { getEnv } from "../helpers/getEnv";

export const STORE_CONFIG = {
  eeStoreUrl: getEnv("VSF_EE_HOST")
    .default("http://localhost:3560")
    .asUrlString(),
  ltStoreUrl: getEnv("VSF_LT_HOST")
    .default("http://localhost:3561")
    .asUrlString(),
  lvStoreUrl: getEnv("VSF_LV_HOST")
    .default("http://localhost:3562")
    .asUrlString(),
  fiStoreUrl: getEnv("VSF_FI_HOST")
    .default("http://localhost:3563")
    .asUrlString(),
  zaStoreUrl: getEnv("VSF_ZA_HOST")
    .default("http://localhost:3564")
    .asUrlString(),
};
